
const errorCodes = {
    "evt-0": {
        "kr": "정상적으로 등록 되었습니다.",
        "en": "You have successfully registered for the event.",
        "pt": "Você se registrou com sucesso no evento.",
        "tw": "已正常登入。",
        "cn": "正常登录完成.",
        "id": "Anda telah berhasil mendaftar untuk acara tersebut."
    },
    "evt-100": {
        "kr": "이벤트 등록 오류가 발생 하였습니다.",
        "en": "An error has occurred in registration.",
        "pt": "Um erro ocorreu durante o registro.",
        "tw": "登入活動發生錯誤。",
        "cn": "活动登录发生错误.",
        "id": "Registrasi gagal"
    },
    "evt-109": {
        "kr": "이미 등록된 메일입니다.",
        "en": "This email address has been registered.",
        "pt": "O endereço de e-mail foi registrado.",
        "tw": "已登錄",
        "cn": "已经登录的邮箱."
    },
    "evt-110": {
        "kr": "이벤트를 찾을 수 없습니다.",
        "en": "Event cannot be found.",
        "pt": "Evento não encontrado.",
        "tw": "無法找到活動。",
        "cn": "无法找到该活动.",
        "id": "Event Tidak Ditemukan"
    },
    "evt-111": {
        "kr": "이벤트가 종료 되었습니다.",
        "en": "Event has terminated.",
        "pt": "O evento acabou.",
        "tw": "活動已結束。",
        "cn": "活动已经结束.",
        "id": "Event Tutup"
    },
    "evt-201": {
        "kr": "이벤트 등록 회수를 초과 하였습니다.",
        "en": "You have reached the maximum number of registration for the event.",
        "pt": "Você chegou ao número máximo de registros para o evento.",
        "tw": "已超過活動登入次數。",
        "cn": "超过活动登录次数.",
        "id": "Anda telah mencapai jumlah maksimum pendaftaran untuk acara tersebut."
    },
    "evt-202": {
        "kr": "이벤트 재등록 오류가 발생 하였습니다.",
        "en": "An error has occurred. You have already registered for this event.",
        "pt": "Um erro ocorreu. Você já se registrou para este evento.",
        "tw": "重新登入活動發生錯誤。",
        "cn": "重复登录活动出现错误.",
        "id": "Terjadi kesalahan. Anda telah terdaftar untuk acara ini."
    },
    "evt-203": {
        "kr": "이미 등록 되어 있습니다.",
        "en": "Already Registered",
        "pt": "Já se Registrou	",
        "tw": "已經註冊",
        "cn": "已经注册",
        "id": "Sudah terdaftar"
    },
    "evt-211": {
        "kr": "스팀 ID를 찾을 수 없습니다.",
        "en": "Steam ID Not Found",
        "pt": "A Steam ID não foi encontrada",
        "tw": "未找到SETAM賬號",
        "cn": "未找到SETAM账号",
        "id": "Megaxus ID Tidak Ditemukan"
    },
    "evt-500": {
        "kr": "알 수 없는 오류가 발생하였습니다. 관리자에게 문의 바랍니다.",
        "en": "An unknown error occurred. Please contact your administrator.",
        "pt": "Um erro desconhecido ocorreu. Por favor contate o administrador.",
        "tw": "發生未知錯誤。請諮詢管理員。",
        "cn": "未知错误.请联系客服."
    },
    "evt-501": {
        "kr": "잘못된 접근 입니다. 접근 경로를 확인 하세요",
        "en": "Access to the path is denied. Please check your access path.",
        "pt": "Acesso ao diretório negado. Por favor verifique o seu diretório de acesso.",
        "tw": "無法進入。請確認進入路徑。",
        "cn": "错误的路径,请确认正确的路径.",
        "id": "Akses Salah"
    },
    "evt-1100": {
        "kr": "잘못된 값을 입력 하였습니다.",
        "en": "Invalid input.",
        "pt": "Comando inválido.",
        "tw": "輸入了錯誤數值。",
        "cn": "输入的数据有误.",
        "id": "Masukan tidak valid."
    },
    "evt-1102": {
        "kr": "이메일 주소를 입력하십시오.",
        "en": "Please enter your email address.",
        "pt": "Por favor, insira seu endereço de email.",
        "tw": "請輸入您的E-mail地址。",
        "cn": "请输入邮箱."
    },
    "evt-1103": {
        "kr": "이메일 형식에 따라 입력하십시오.",
        "en": "Please enter it according to the email format.",
        "pt": "Por favor, insira de acordo com o formato de email.",
        "tw": "請按照E-mail格式輸入。",
        "cn": "请按照邮箱格式输入."
    },
    "evt-1104": {
        "kr": "숫자를 입력하십시오.",
        "en": "Please enter a number.",
        "pt": "Por favor, insira um número.",
        "tw": "請輸入號碼。",
        "cn": "请输入数字."
    },
    "evt-1105": {
        "kr": "숫자만 입력하십시오.",
        "en": "Please enter a number only.",
        "pt": "Por favor, insira somente um número.",
        "tw": "請輸入一個數字。",
        "cn": "仅输入数字."
    },
    "evt-1106": {
        "kr": "URL을 입력하십시오.",
        "en": "Please enter the URL.",
        "pt": "Por favor, insira a URL.",
        "tw": "請輸入連結。",
        "cn": "请输入链接."
    },
    "evt-1107": {
        "kr": "URL 형식에 따라 입력하십시오.",
        "en": "Please enter it according to the URL format.",
        "pt": "Por favor, insira de acordo com o formato de URL.",
        "tw": "請按照連結格式輸入。",
        "cn": "请按照链接格式输入."
    },
    "evt-1108": {
        "kr": "개인정보 수집 및 이용 동의 시 이벤트 참여가 가능합니다.",
        "en": "Players must agree to Collection of Personal Information & Agreement to Use to participate in the event.",
        "pt": "Jogadores devem concordar com o Acordo de Coleta & Uso de Informações Pessoais para participar do evento.",
        "tw": "同意個人信息收集和使用時可以參加活動.",
        "cn": "同意个人信息收集和使用时可以参加活动.",
        "id": "Pemain harus menyetujui Collection of Personal Information & Agreement to Use untuk berpartisipasi dalam acara tersebut."
    },
    "evt-230": { "kr": "유효하지 않은 인증 정보입니다.", "en": "Invalid authentication information.", "pt": "Informação de autenticação inválida.", "cn": "无效的认证信息。", "tw": "無效的認證信息。", "id": "Kredensial tidak valid." },
    "evt-230": { "kr": "유효하지 않은 인증 정보입니다.", "en": "Invalid authentication information.", "pt": "Informação de autenticação inválida.", "cn": "无效的认证信息。", "tw": "無效的認證信息。", "id": "Kredensial tidak valid." },
    "evt-231": { "kr": "토큰이 만료되었습니다. 다시 로그인을 진행해 주세요.", "en": "Token has expired. Please log in again.", "pt": "Token expirou. Por favor entre novamente.", "cn": "令牌已过期。请重新登录。", "tw": "令牌已過期。請重新登錄。", "id": "Token kamu telah kedaluwarsa. Silakan coba login lagi." },
    "evt-300": { "kr": "Megaxus 계정을 확인할 수 없습니다.", "en": "Megaxus Account not found.", "pt": "Conta Megaxus não encontrada.", "cn": "无法确认Megaxus账号.", "tw": "無法確認Megaxus賬號.", "id": "Tidak dapat memverifikasi akun Megaxus." },
    "evt-400": { "kr": "PlayPark 계정을 확일할 수 없습니다.", "en": "Playpark Account not found.", "pt": "Conta Playpark não encontrada.", "cn": "无法确认PlayPark账号.", "tw": "無法確認PlayPark賬號.", "id": "Tidak dapat memverifikasi akun PlayPark." },
    "evt-410": { "kr": "PlayPark OTP 자리수가 일치하지 않습니다.", "en": "PlayPark OTP digis do not match.", "pt": "Dígitos do OTP Playpark não correspondem.", "cn": "PlayPark OTP数字不一致.", "tw": "PlayPark OTP數字不一致.", "id": "Angka OTP PlayPark tidak cocok." },
    "evt-411": { "kr": "PlayPark OTP가 일치하지 않습니다.", "en": "PlayPark OTP does not match.", "pt": "OTP Playpark não corresponde.", "cn": "PlayPark OTP不一致.", "tw": "PlayPark OTP不一致.", "id": "OTP PlayPark tidak cocok." },
    "evt-420": { "kr": "잘못된 요청 입니다. 다시 로그인 해주세요", "en": "Login failed. Please try again.", "pt": "Falha no login. Por favor, tente novamente.", "cn": "错误的请求.请重新登录.", "tw": "錯誤的請求.請重新登錄.", "id": "Permintaan tidak valid. Silakan masuk lagi" },
    "evt-700": { "kr": "Steam 계정을 확인할 수 없습니다.", "en": "Steam Account not found.", "pt": "Conta Steam não encontrada.", "cn": "无法确认Steam账号.", "tw": "無法確認Steam賬號.", "id": "Tidak dapat memverifikasi akun Steam." },
    "evt-800": { "kr": "Epic 계정을 확인할 수 없습니다.", "en": "Epic Account not found.", "pt": "Conta Epic não encontrada.", "cn": "无法确认Epic账号.", "tw": "無法確認Epic賬號.", "id": "Tidak dapat memverifikasi akun Epic." },
    "evt-900": { "kr": "Gamania 계정을 확인할 수 없습니다. ", "en": "Cannot find Gamania Account.", "pt": "Não foi possível encontrar sua conta Gamania.", "cn": "无法确认 Gamania 账号。", "tw": "無法確認 Gamania 賬號。", "id": "Akun Gamania tidak dapat diverifikasi." },
    "evt-801": { "kr": "Epic 로그인에 실패했습니다. 다시 로그인 해주세요.", "en": "Epic login failed. Please try again.", "pt": "Falha no login Epic. Por favor, tente novamente.", "cn": "Epic账户登录失败.请重新登录.", "tw": "Epic賬戶登錄失敗.請重新登錄.", "id": "Proses Login Epic gagal. Silakan masuk lagi." },
    "evt-1200": { "kr": "아이디를 입력해주세요.", "en": "Please enter the username.", "pt": "Por favor insira o nome de usuário.", "cn": "请输入账号.", "tw": "請輸入賬號.", "id": "Masukkan ID Kamu." },
    "evt-1201": { "kr": "비밀번호를 입력해주세요.", "en": "Please enter the password.", "pt": "Por favor insira a senha.", "cn": "请输入密码.", "tw": "請輸入密碼.", "id": "Masukkan Password Kamu." },
    "evt-1202": { "kr": "잘못된 계정 또는 비밀번호입니다. 다시 로그인 해주세요.", "en": "Incorrect ID or Password. Please try again.", "pt": "ID ou Senha incorreta. Por favor tente novamente.", "cn": "错误的账号或密码", "tw": "錯誤的帳號或密碼", "id": "ID atau Password salah. Silakan login kembali." },
    "evt-1203": { "kr": "포인트 계정이 잠금 상태입니다.", "en": "The Point account is locked.", "pt": "A conta de Point está trancada.", "cn": "点数账号已锁定", "tw": "點數帳號已鎖定", "id": "Poin Akun terkunci." },
    "evt-20100": { "kr": "게임아이디가 이미 등록되어있습니다.", "en": "Game ID is already registered.", "pt": "ID do Jogo já registrado.", "cn": "游戏ID已被注册。", "tw": "遊戲ID已被注冊。", "id": "ID Game sudah terdaftar." },
    "evt-20101": { "kr": "트위치 아이디가 이미 등록되어있습니다.", "en": "Twitch ID is already registered.", "pt": "ID da Twitch já registrado.", "cn": "Twitch ID已被注册。", "tw": "Twitch ID已被注冊。", "id": "ID Twitch kamu sudah terdaftar." }
}



export { errorCodes }